import template from './tableComponent.html';
import controller from './tableComponent.controller';

let tableComponentComponent = {
  restrict: 'E',
  bindings: {
    columns: '=',
    options : '=',
    metaData : '=',
    sortBy: '=',
    data: '=',
    getNextSetOfRowsToFetch : '&',
    toggleSort : '&',
    toggleHeaderCheckbox: '&',
    rowOptions: '=',
    searchValue: '=',
    refreshOnShow: '=',
    fetchResults: '&'
  },
  transclude: {
    'pagination': '?paginationBar'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default tableComponentComponent;



// WEBPACK FOOTER //
// ./app/components/tableComponent/tableComponent.component.js